import { compose, alignItems, alignContent, justifyContent, justifyItems, flexWrap, flexBasis, flexShrink, flexGrow, flexDirection, flex, justifySelf, alignSelf, order } from '../node_modules/@xstyled/system/dist/xstyled-system.es.js';

var flexboxes = compose(alignItems, alignContent, justifyContent, justifyItems, flexWrap, flexBasis, flexShrink, flexGrow, flexDirection, flex, justifySelf, alignSelf, order);

export { flexboxes };
//# sourceMappingURL=system.js.map
